export enum ComponentId {
  VEHICLE_TYPE = "type",
  REGISTRATION_NUMBER = "registrationNumber",
  VIN = "vin",
  PRODUCTION_YEAR = "productionYear",
  MAKE = "make",
  MODEL = "model",
  REGISTRATION_DATE = "registrationDate",
  DESCRIPTION = "description",
}
